module.exports = __webpack_public_path__ + "static/img/office_5.6ec8ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/office_5.png
// module id = azh0
// module chunks = 0